import React, { useContext } from "react";
import { AppContext } from "../window";
import { SliderContext } from "./App";
import { useEffect, useState } from "react";
import { useTranslation } from "../i18n";


interface PayModalProps {
  onUpgradeClick: (upgradeName: string) => void;
}

export const PayModal: React.FC<PayModalProps> = ({ onUpgradeClick }) => {
  const { t } = useTranslation();
  const { user: authorizedUser, texts } = useContext(AppContext);
  const { user, legacyMode } = useContext(SliderContext);
  const [isPremium, setIsPremium] = useState<boolean>(false);

  useEffect(() => {
    if(!authorizedUser?.wallet?.premiumExpiry) {
      setIsPremium(false);
      return;
    }
    setIsPremium(new Date(authorizedUser.wallet.premiumExpiry) > new Date());
  }, [authorizedUser?.wallet?.premiumExpiry]);

  if (!user) {
    return null;
  }

  let premium = null;
  if (!isPremium) {
    premium = (
      <button
        className="btn btn-success btn-block mb-2"
        type="button"
        onClick={() => {
          if (legacyMode) {
            window.location.href = `/user/slider/premium?requestedUserId=${user.id}`;
          } else {
            onUpgradeClick('premium');
          }
        }}
      >
        {texts.goPremium || t('slider.go_premium')}*
        <div className="credits badge bg-danger">{t('slider.credits_cost')}</div>
      </button>
    );
  }

  return (
    <div className="pay">
      <p className="text">{texts.reachedLimit || t('slider.reached_limit')}</p>
      <p className="small mb-4">{texts.returnOrContinue || t('slider.return_or_continue')}</p>
      <div className="d-grid gap-3">
        {premium}
        <button
          className="btn btn-primary btn-block"
          type="button"
          onClick={() => {
            if (legacyMode) {
              window.location.href = `/user/slider/upgrade?requestedUserId=${user.id}`;
            } else {
              onUpgradeClick("matches");
            }
          }}
        >
          <div className="credits badge bg-danger">{t('slider.matches_cost')}</div>
          {texts.moreMatches || t('slider.more_matches')}
        </button>
      </div>
      <p className="small">
        {!isPremium ? `* ${texts.premiumDescription || t('slider.premium_description')}` : ""}
      </p>
    </div>
  );
};
